import axios from "../../../utils/axios";
import { ISubmitCalculateClientFee } from "../types/tools.types";

export async function calculateONNClientFees(data: ISubmitCalculateClientFee) {
    const response = await axios.post(`/tools/calculate-fees`, data);
    return response.data;
}

export async function calculatePsychClientFees(
    data: ISubmitCalculateClientFee
) {
    const response = await axios.post(`/tools/calculate-psych-fees`, data);
    return response.data;
}
